import { Component, OnInit } from '@angular/core';
import { Application } from '../../../shared/user.model';
import { UserService } from '../../../shared/user.service';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import swal1 from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../../shared/ErrorHandler';
import { Search } from '../../../shared/user.model';

@Component({
  selector: 'enactment-grid',
  templateUrl: './enactment-grid.component.html',
  styleUrls: ['./enactment-grid.component.css']
})
export class EnactmentGridComponent implements OnInit {

title="Enactment";

  itemsPerPage: number=5;
  currentPage: number=1;
  EnactmentsDetailsList : any = {};
  data : any = {};  
  totalItems : number;
  s: Search;
  isSearch:boolean = false;
  Enactment_id : number;
  constructor(private UserService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) {
    this.s = new Search();
    this.isSearch = false;
   }
   ngOnInit() { 
    this.GetEnactmentsDetails(this.itemsPerPage, 1)
  }

 

  //List of Case Proceedings
  GetEnactmentsDetails(itemsPerPage:any,pageNo:any){
  //alert('Inside');
  this.isSearch = false;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.UserService.GetEnactmentsDetails(itemsPerPage,pageNo);
    this.data.subscribe(
      (response: any) => {
        this.EnactmentsDetailsList = response.EnactmentsModel;
          this.totalItems = response.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;
        console.log('Enactments Deatils');
        console.log(this.EnactmentsDetailsList);    
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401|| error.status == 500) {
          this.errorHandler.HandlerError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  delete(Enactment_id){
    swal({
       title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
     }).then((result) => {
        if (result.value) {
        this.data = this.UserService.DeleteEnactments(Enactment_id);
        this.data.subscribe(
         (response: any) => {
          this.GetEnactmentsDetails(this.itemsPerPage, 1)
            //alert('Inside');;          
         },(error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401|| error.status == 500) {
            this.errorHandler.HandlerError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        }      
      ); 
    } 
    })
    }

    pageChanged(pageNumber: number) {
      if (this.isSearch)
        this.onSearch(this.s, this.itemsPerPage, pageNumber);
      else
        this.GetEnactmentsDetails(this.itemsPerPage, pageNumber);
    }
  
    itemsPerPageChanged(itemsPerPage: number, pageNo: number) {
      if (this.isSearch)
        this.onSearch(this.s, this.itemsPerPage, pageNo);
      else
        this.GetEnactmentsDetails(this.itemsPerPage, pageNo);
    }


  //Search item


  onSearch(s, itemsPerPage: number, pageNo: number) {   
    this.isSearch = true;
    let searchText = this.s.SearchText;
    let searchCriteria = this.s.SearchCriteria;
    if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
      swal("Warning!", "Please enter the search criteria and search text.", "warning");
    else {
      document.getElementById('loader-spinner').style.display = "block";
      this.UserService.SearchEnactments(searchCriteria, searchText, itemsPerPage, pageNo)
        .subscribe(
          (data: any) => {
            if(data.EnactmentsModel.length!=0){              
            this.EnactmentsDetailsList = data.EnactmentsModel;
            this.totalItems = data.TotalItemsCount;
            this.currentPage = pageNo;
            document.getElementById('loader-spinner').style.display = "none";
          }
          else
          {
          document.getElementById('loader-spinner').style.display = "none";         
          }
          },(error) => {
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401|| error.status == 500) {
              this.errorHandler.HandlerError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
          });
    }
  }



}



// WEBPACK FOOTER //
// ./src/app/masters/Enactment/enactment-grid/enactment-grid.component.ts